var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.user !== "个人简历"
        ? _c("div", [
            _vm.imageUrl
              ? _c("div", { staticClass: "avatar" }, [
                  _c("img", {
                    staticClass: "img",
                    attrs: { src: _vm.imageUrl },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "avatar-upload" }, [
                    _c("div", { staticClass: "avatar-upload-content" }, [
                      _c("i", {
                        staticClass: "el-icon-zoom-in",
                        on: { click: _vm.handlePictureCardPreview },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-icon-delete",
                        on: { click: _vm.handleAvatar },
                      }),
                    ]),
                  ]),
                ])
              : _c("i", {
                  staticClass: "el-icon-plus avatar-uploader-icon",
                  on: { click: _vm.beforeUpload },
                }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.user == "个人简历"
        ? _c(
            "div",
            { staticClass: "avatar" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo mr10 mb15",
                  attrs: {
                    headers: _vm.myHeaders,
                    "http-request": _vm.uploadServerLog,
                    "show-file-list": false,
                    action: "##",
                    multiple: "",
                  },
                },
                [
                  _vm.imageUrl
                    ? _c("img", {
                        staticClass: "img",
                        attrs: { src: _vm.imageUrl },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        _vm._b(
          {
            attrs: {
              "before-close": _vm.handleClose,
              visible: _vm.dialogVisible,
              title: "选择图片",
              width: "850px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          "el-dialog",
          _vm.$attrs,
          false
        ),
        [
          _c("upload-picture", {
            ref: "uploadPicture",
            attrs: { "check-button": true },
            on: { getImage: _vm.getImage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }